'use strict';

var Sugar = require('sugar-core'),
    getAcronym = require('../common/internal/getAcronym'),
    getHumanWord = require('../common/internal/getHumanWord'),
    inflectHumans = require('../inflections/var/inflectHumans'),
    simpleCapitalize = require('../common/internal/simpleCapitalize');

Sugar.String.defineInstance({

  'humanize': function(str) {
    str = inflectHumans(str);
    str = str.replace(/(_)?([a-z\d]*)/gi, function(match, _, word) {
      word = getHumanWord(word) || word;
      word = getAcronym(word) || word.toLowerCase();
      return (_ ? ' ' : '') + word;
    });
    return simpleCapitalize(str);
  }

});

module.exports = Sugar.String.humanize;